import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import securityCodeImage from '../../../../../../public/static/books/security-code.png';

import css from './PurchaseSecurityCodeMessage.module.scss';

interface Props {
  className?: string;
}

const PurchaseSecurityCodeMessage = ({
  className,
  intl,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.PurchaseSecurityCodeMessage, className);

  return (
    <div className={classes}>
      <img
        className={css.PurchaseSecurityCodeMessage__Img}
        src={securityCodeImage}
        alt="Security Code"
      />
      <p className={css.PurchaseSecurityCodeMessage__Text}>
        {intl.formatMessage({
          id: 'purchases.purchaseSecurityCodeMessage.message',
        })}
      </p>
    </div>
  );
};

export default injectIntl(PurchaseSecurityCodeMessage);
